import { RATE_RESET_ENUM } from '../enums/rate-reset.enum';

export const RATE_RESET = [
  { id: RATE_RESET_ENUM.IN_ADVANCE, displayValue: 'In Advance' },
  { id: RATE_RESET_ENUM.IN_ARREARS, displayValue: 'In Arrears' },
  { id: RATE_RESET_ENUM.DAILY, displayValue: 'Daily' },
];
